import { Definition,  Ref } from '../../framework/infra'

export default class ConfigCommittee extends  Ref {
    static definitions = {
        address: { ref: require('../address/Address'), text: 'Address', text_fr: 'Adress' },
    }
}
